<div class="input-group" [class.clean-addons]="cleanAddons">
    <ng-content></ng-content>
</div>
